import React from 'react';
import { motion } from 'framer-motion';
export function ComparativeSection() {
  return <section className="py-16 md:py-24 px-5 md:px-8" data-id="element-96">
      <div className="max-w-5xl mx-auto" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-98">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-99">
            Esto no es otro audio genérico de relajación
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-100">
          {/* Green Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#0B1224] p-8 rounded-2xl border-t-4 border-green-500 shadow-lg" data-id="element-101">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-102">
              Por qué sí es distinto
            </h3>
            <ul className="space-y-4" data-id="element-103">
              {['No intenta prometer una cura milagrosa.', 'No depende de comprar aparatos.', 'No requiere sesiones largas.', 'Se enfoca en la atención, el cuerpo y la habituación.', 'Está diseñado específicamente para la noche.'].map((text, i) => <li key={i} className="flex gap-3 text-gray-300" data-id="element-104">
                  <span className="text-green-500 mt-1" data-id="element-105">✓</span>
                  <span data-id="element-106">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Red Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-[#0B1224] p-8 rounded-2xl border-t-4 border-red-500 shadow-lg" data-id="element-107">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-108">
              Por qué otros métodos se quedan cortos
            </h3>
            <ul className="space-y-4" data-id="element-109">
              {['Solo tapan el sonido temporalmente.', 'No cambian la reacción emocional al zumbido.', 'No enseñan al cerebro a soltar la vigilancia.', 'Funcionan mientras están encendidos, pero el problema vuelve cuando todo queda en silencio.'].map((text, i) => <li key={i} className="flex gap-3 text-gray-300" data-id="element-110">
                  <span className="text-red-500 mt-1" data-id="element-111">✕</span>
                  <span data-id="element-112">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}